import React, {useEffect} from "react";

import {Config, configureApiClient} from "../services/api";
import {dispatch, select, store} from "../store";
import {AUTH_SIGN_IN_URL} from "../services/AuthService";
import {useClearAndCancelCache} from "../hooks/useClearAndCancelCache";
import {AxiosRequestConfig} from "axios";
import {configureRestApiClient} from "../services/api/restApiClient";

const createConfig = (clearAndCancelCache: () => void): Config => ({
  getToken: () => select.adminSession.getToken(store.getState()),
  setToken: (token: string) =>
    dispatch.adminSession.setToken({token, isLoginToken: false}),
  logout: () => {
    dispatch.adminSession.logout();
    clearAndCancelCache();
  },
  // auth/sign-in will respond with status UNAUTHORIZED for bad password and login combination
  skipUnauthorizedHandling: (config: AxiosRequestConfig) => {
    return config?.url === AUTH_SIGN_IN_URL;
  },
});

// Custom hooks for configuring API clients
export const useApiClientConfiguration = (config: Config) => {
  useEffect(() => {
    configureApiClient(config);
  }, [config]);
};

export const useRestApiClientConfiguration = (config: Config) => {
  useEffect(() => {
    configureRestApiClient(config);
  }, [config]);
};

// Configuration components
export const AdminApiClientConfiguration: React.FC<{
  children?: React.ReactNode;
}> = ({children}) => {
  const {clearAndCancelCache} = useClearAndCancelCache();
  const config = createConfig(clearAndCancelCache);

  useApiClientConfiguration(config);

  return <div>{children}</div>;
};

export const RestApiClientConfiguration: React.FC<{
  children?: React.ReactNode;
}> = ({children}) => {
  const {clearAndCancelCache} = useClearAndCancelCache();
  const config = createConfig(clearAndCancelCache);

  useRestApiClientConfiguration(config);

  return <div>{children}</div>;
};

export const AdmissionApiClientConfiguration: React.FC<{
  children?: React.ReactNode;
}> = ({children}) => {
  const config: Config = {
    getToken: () => select.admissionSession.getToken(store.getState()),
    setToken: dispatch.admissionSession.setToken,
    logout: dispatch.admissionSession.logout,
  };

  useApiClientConfiguration(config);

  return <div>{children}</div>;
};
